export const validation = {
  firstName: {
    min: 1,
    max: 90
  },
  lastName: {
    min: 1,
    max: 90
  },
  country: {
    min: 1,
    max: 90
  },
  city: {
    min: 1,
    max: 200
  },
  address: {
    min: 1,
    max: 100
  },
  zipCode: {
    min: 1,
    max: 20
  },
  email: {
    max: 200,
    regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  },
  phone: {
    min: 6,
    max: 40,
    regex: /\+[0-9]*$/
  },
  propertyType: {
    min: 1,
    max: 150
  },
  serialNumber: {
    min: 2,
    max: 50
  },
  comment: {
    max: 600
  },
  dateYYMMDD: {
    regEx: /^\d{4}-\d{2}-\d{2}/
  }
};
